/**
 * Lightweight stale-while-revalidate cache for Admin tab data.
 * Data persists for the lifetime of the browser session (not localStorage).
 */
const store = new Map();
const TTL_MS = 60_000; // 1 minute before "stale"

export function setCached(key, data) {
  store.set(key, { data, ts: Date.now() });
}

export function getCached(key) {
  const entry = store.get(key);
  if (!entry) return null;
  return { data: entry.data, stale: Date.now() - entry.ts > TTL_MS };
}

export function clearCache(key) {
  if (key) store.delete(key);
  else store.clear();
}
